<template>



    <div class="row align-items-center mb-3 attribute mx-0">
        <div class="col-lg-12 col-xl-12">
            <div class="row align-items-center">
                <div class="col-md-2 my-2 my-md-0">
                    <h4>{{ attribute.attribute.name }}</h4>
                </div>
                <div v-if="getOptionsLength > 0" class="col-md-6 my-2 my-md-0">
                    <template v-for="(option, i) in attribute.options" >
                        <b-button v-bind:key="i" size="sm" class="mx-1 my-1" @click="editAttributeOptions">{{option.name}}</b-button>
                    </template>
                </div>

                <div v-if="getOptionsLength === 0" class="text-center col-md-6 my-2 my-md-0">
                    Нет свойств в данном атрибуте! <a href="javascript:void(0)" @click="editAttributeOptions">Добавить свойства</a>
                </div>

                <div class="col-md-4 my-2 my-md-0 text-right">
                    <b-button style="cursor: move;" size="sm" class="mr-2 hand"><i class="fas fa-arrows-alt-v"></i></b-button>
                    <b-button @click="editAttributeOptions" size="sm" class="mr-2" variant="primary">Редактировать</b-button>
                    <b-button @click="deleteModal" size="sm" variant="danger">Удалить</b-button>
                </div>
            </div>
        </div>

        <b-modal ref="edit-options-modal" centered hide-footer title="Редактировать атрибут">
            <div class="d-block">

                <div class="form-group mb-2">
                    <label class="font-size-h3 font-weight-bolder text-dark mb-7">{{attribute.attribute.name}} (варианты)</label>
                    <!--begin::Checkbox list-->
                    <div class="checkbox-list">
                        <label class="checkbox checkbox-lg mb-4">
                            <input type="checkbox" name="electronics" v-model="selectAll"/>
                            <span></span>
                            <div class="font-size-lg text-dark-75 font-weight-bold">Выбрать все свойства</div>
                        </label>

                        <hr class="mt-0">
                        <template v-for="option in edit_attribute.attribute.options" >
                            <label v-bind:key="option.id" class="checkbox checkbox-lg mb-7">
                                <input v-model="edit_attribute.options" :value="option"  type="checkbox" name="electronics"/>
                                <span></span>
                                <div class="font-size-lg text-dark-75 font-weight-bold">{{option.name}}</div>
                                <div @click="selectOptionImage(option.id)" v-if="edit_attribute.image == '1' && edit_attribute.image_type === 'customized'" class="ml-auto text-muted font-weight-bold">
                                    <b-button :style="{backgroundColor: option.color}" style="padding: 2px" >
                                        <div class="d-flex align-items-center">
                                            <div class="symbol symbol-50 flex-shrink-0" style="min-width: 48px;min-height: 48px;">

                                                <template v-for="(image, i) in edit_attribute.images">
                                                    <div v-bind:key="i" class="ui-sortable">
                                                    <div v-if="image.option === option.id" class="symbol-label" :style="{ backgroundImage: 'url(' + $urlBackEnd(image.thumbnail) + ')' }"></div>
                                                    </div>
                                                </template>

                                            </div>
                                        </div>
                                    </b-button>
                                </div>

                                <div v-else-if="edit_attribute.attribute.type === 'color'" class="ml-auto text-muted font-weight-bold">
                                    <b-button
                                        :style="{backgroundColor: option.color} "
                                        style="min-width: 25px; min-height: 25px;"
                                        size="sm" class="mr-2">
                                    </b-button>
                                </div>

                                <div v-else class="ml-auto text-muted font-weight-bold">{{option.id}}</div>
                            </label>
                        </template>
                    </div>
                    <!--end::Checkbox list-->

                    <div class="card card-custom card-stretch gutter-b">

                        <div class="card-body pt-5 pb-5">

                            <div v-if="edit_attribute.attribute.options.length === 0" role="alert" class="alert alert-warning alert-dismissible text-dark text-center">
                                <strong><i class="fa fa-info-circle"></i> Внимание!</strong>
                                <br>В данном атрибуте не добавлены опции.<br>Добавьте опции с помощью формы ниже, или на страницы атрибута.
                            </div>

                            <label class="font-size-h4 font-weight-bolder text-dark mb-3">Создать новую опцию</label>

                            <div class="form-group mt-3 mb-2">
                                <label>Название опции</label>
                                <div class="input-group">
                                    <b-form-input
                                            v-model.trim="new_option.name"
                                            :class="{'is-invalid': errorsOption.name}"
                                            placeholder="Название опции"
                                            required
                                    ></b-form-input>
                                    <div class="input-group-append">
                                        <button @click="AddOption" ref="add_option" class="btn btn-primary" type="button">Создать</button>
                                    </div>
                                </div>
                                <div v-if="errorsOption.name" class="invalid-feedback">{{errorsOption.name[0]}}</div>
                                <small>Введите название опции. Например: черный (Если атрибут является цветом)</small>
                            </div>

                            <b-form-group v-if="edit_attribute.attribute.type === 'color'"
                                          description="Выберите цвет"
                                          label="Цвет опции"
                            >
                                <b-form-input
                                        v-model="new_option.color"
                                        :class="{'is-invalid': errorsOption.color}"
                                        type="color"
                                ></b-form-input>
                                <div v-if="errorsOption.color" class="invalid-feedback">{{errorsOption.name[0]}}</div>
                            </b-form-group>

                        </div>
                    </div>

                    <div class="form-group row mb-0">
                        <b-form-group class="col-lg-12 mb-2"
                                      label="Картинки в опциях"
                                      description="Опция этого атрибута будет отображаться в виде изображения."
                        >
                            <b-form-checkbox
                                    size="lg"
                                    v-model="edit_attribute.image"
                                    value="1"
                                    unchecked-value="0"
                            >
                                Включить изображение опций в этом атрибуте
                            </b-form-checkbox>

                        </b-form-group>


                        <b-form-group v-if="edit_attribute.image == '1'" class="col-lg-12 mb-2" label="Тип изображения:">
                        <b-form-select v-model="edit_attribute.image_type">

                            <option value="variant">Первое изображение вариации</option>
                            <option value="customized">Индивидуальное изображение опции</option>

                        </b-form-select>

                            <small v-if="edit_attribute.image_type === 'variant'">Опция этого атрибута будет отображаться в виде первого изображения вариации.</small>
                            <small v-if="edit_attribute.image_type === 'customized'">Опция этого атрибута будет отображаться в виде индивидуального изображения.</small>

                        </b-form-group>

                    </div>


                </div>
            </div>

            <b-button ref="save-attribute-button" class="mt-3" variant="outline-primary" block @click="saveEditOptions">Сохранить</b-button>
        </b-modal>
        <b-modal ref="delete-attribute" centered hide-footer hide-header title="Подтвердите действие">
            <div class="d-block text-center">
                <h3>Удалить атрибут: {{attribute.attribute.name}}?</h3>
                <p>Внимание: При удаление атрибута вы удаляете его из всех вариаций товара. Убедитесь в отсутствии вариации с данным атрибутом</p>
            </div>
            <b-row>
                <b-col>
                    <b-button class="mt-3" variant="outline-primary" block @click="hideModalDelete">Отмена</b-button>
                </b-col>
                <b-col>
                    <b-button class="mt-3" ref="delete-attribute-button" variant="outline-danger" block @click="deleteAttribute">Удалить</b-button>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal ref="delete-attribute-fail" centered hide-footer title="Сообщение">
            <div class="d-block text-center">
                <h3>Невозможно удалить атрибут</h3>

                <div role="alert" class="alert alert-danger alert-dismissible text-white">
                    <strong><i class="fa fa-info-circle"></i> Внимание!</strong>
                    <br>Имеются вариации с этим атрибутом
                </div>
            </div>

            <b-button class="mt-3" variant="primary" block @click="hideModalDelAttributeFail">Закрыть</b-button>

        </b-modal>

        <b-modal ref="edit-options-fail" centered hide-footer title="Сообщение">
            <div class="d-block text-center">
                <h3>Невозможно удалить
                    <template v-if="options_fail.length > 1">опции</template>
                    <template v-else >опцию</template></h3>
                <div role="alert" class="alert alert-danger alert-dismissible text-white">
                    <strong><i class="fa fa-info-circle"></i> Внимание!</strong>
                    <br>Имеются вариации с
                    <template v-if="options_fail.length > 1">этими опциями:</template>
                    <template v-else >этой опцией:</template>
                    <br><strong v-bind:key="i" v-for="(option, i) in options_fail">{{ option.name }} </strong>
                </div>
            </div>

            <b-button class="mt-3" variant="primary" block @click="hideModalDelOptionFail">Закрыть</b-button>

        </b-modal>

        <b-modal id="select-image-options" hide-footer ref="select-image-options" title="Выберите изображение" ok-only>
            <ul class="ui-sortable">
                <li v-bind:key="i" class="image" v-for="(pr, i) in product.images" >
                    <b-img @click="selectImageOption(pr)" thumbnail fluid :src="$urlBackEnd(pr.thumbnail)" alt="Image" style="cursor: pointer"></b-img>
                </li>
            </ul>

            <vue-dropzone ref="myVueDropzone"
                          id="dropzone"
                          :options="dropzoneOptions"
                          :useCustomSlot=true
                          v-on:vdropzone-success="successDrop"
                          v-on:vdropzone-max-files-exceeded="maxDrop"
            >
                <div class="dropzone-custom-content">
                    <b class="dropzone-custom-title">Загрузите файлы</b>
                    <div class="subtitle">...или перетащите их сюда</div>
                </div>
            </vue-dropzone>

        </b-modal>


    </div>
</template>

<script>

    import { mapGetters } from "vuex";
    import vue2Dropzone from 'vue2-dropzone';
    import {
        DETACH_ATTRIBUTE_TO_PRODUCT,
        GET_ATTRIBUTES,
        UPDATE_ATTRIBUTE_TO_PRODUCT
    } from "../../../../core/services/store/attributes.module";
    import {SET_ALERT} from "../../../../core/services/store/alert.module";
    import {ADD_ATTRIBUTE_OPTION} from "../../../../core/services/store/attributesOptions.module";
    export default {
        name: "AttributeInProduct",
        props: [ 'attribute'],
        components: {
            vueDropzone: vue2Dropzone
        },
        computed: {

            ...mapGetters({
                product: 'gettersProduct',
                errorsOption: 'errorsAttributeOption',
            }),

            getOptionsLength() {
                return this.attribute.options.length
            },


            currentRouteName() {
                return this.$route.name;
            },

            selectAll: {
                get: function () {
                    return this.edit_attribute.attribute.options ? this.edit_attribute.options.length == this.edit_attribute.attribute.options.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.edit_attribute.attribute.options.forEach(function (options) {
                            selected.push(options);
                        });
                    }

                    this.edit_attribute.options = selected;
                }
            }

        },
        data(){
            return{

                new_option: {
                    name: '',
                    color: '#ffffff'
                },

                options_fail: [],

                image_option: null,

                edit_attribute: {
                    attribute: {
                       name: '',
                       options: []
                    },
                    options: [],
                    image: 0,
                    image_type: 'variant',
                    images: []
               },

                dropzoneOptions: {
                    url: this.$urlBackEnd('/api/v1/product/images'),
                    acceptedFiles: '.jpg, .jpeg, .png,',
                    thumbnailWidth: 200,
                    maxFilesize: 8,
                    maxFiles:50,
                    headers: { "Authorization": 'Bearer ' + localStorage.getItem('id_token') },
                    parallelUploads: 1,
                    createImageThumbnails: true,
                    uploadMultiple: false,
                },
            }
        },

        methods:{

            selectOptionImage(id){
                this.image_option = id;
                this.$refs['select-image-options'].show()
            },

            selectImageOption(image){
                const img = {
                    option: this.image_option,
                    thumbnail: image.thumbnail,
                };
                if (this.edit_attribute.images.find(obj => obj.option === img.option)){
                    var indexToOption = this.edit_attribute.images.findIndex(obj => obj.option === img.option);
                    this.edit_attribute.images.splice(indexToOption , 1);
                }
                this.edit_attribute.images.push(img);
                this.$refs['select-image-options'].hide()
            },

            successDrop (file, response) {
                this.$refs.myVueDropzone.removeFile(file);
                const img = {
                    option: this.image_option,
                    thumbnail: response.thumbnail,
                };
                if (this.edit_attribute.images.find(obj => obj.option === img.option)){
                    var indexToOption = this.edit_attribute.images.findIndex(obj => obj.option === img.option);
                    this.edit_attribute.images.splice(indexToOption , 1);
                }
                this.edit_attribute.images.push(img);
                this.$refs['select-image-options'].hide()
            },

            maxDrop (){

            },

            deleteAttribute(){

                const submitButton = this.$refs["delete-attribute-button"];
                submitButton.classList.add("spinner", "spinner-light", "spinner-right");

                var errors = false;
                if (this.product.variants.length > 0) {
                    var _ = this;
                    this.product.variants.forEach(function (variation) {
                        if (variation.attributes.find(attribute => attribute.attribute_id === _.attribute.attribute_id)) {
                            errors = true;
                        }
                    });
                }

                if (!errors) {
                    if (this.currentRouteName === 'AddProduct') {
                        this.$emit('delete_attribute', this.attribute.id);
                        this.$refs['delete-attribute'].hide();
                        this.showAlert('Атрибут успешно удален', 'success', 'toast');
                    } else {
                        this.$store.dispatch(DETACH_ATTRIBUTE_TO_PRODUCT, {product: this.product.id, attribute: this.attribute.id})
                            .then(() => {
                                this.$emit('delete_attribute', this.attribute.id);
                                this.showAlert('Атрибут успешно удален ', 'success', 'toast');
                            })
                            .catch(() => {
                                this.showAlert('Ошибка удаления', 'danger', 'toast');
                            })
                            .finally(()=>{
                                submitButton.classList.remove("spinner", "spinner-light", "spinner-right")
                                this.$refs['delete-attribute'].hide();
                            })
                    }

                } else {
                    this.$refs['delete-attribute'].hide();
                    this.$refs['delete-attribute-fail'].show();
                    submitButton.classList.remove("spinner", "spinner-light", "spinner-right")
                    this.showAlert('Невозможно удалить. Имеются вариации с данным атрибутом', 'danger', 'toast');
                }

            },

            hideModalDelAttributeFail(){
                this.$refs['delete-attribute-fail'].hide()
            },


            editAttributeOptions(){

                this.edit_attribute = this.lodash.cloneDeep(this.attribute);
                this.$refs['edit-options-modal'].show()
            },

            saveEditOptions(){

                var errors = false;
                this.options_fail = [];
                if (this.product.variants.length > 0) {
                    var options = [];
                    var fail_options = [];
                    var _ = this;

                    this.attribute.options.forEach(function (o) {
                        if (!_.edit_attribute.options.find(option => option.id === o.id)) {
                            options.push({name: o.name, id: o.id})
                        }
                    });

                    if (options.length > 0) {
                        this.product.variants.forEach(function (variant) {
                            variant.attributes.forEach(function (attribute) {
                                if (attribute.attribute_id === _.attribute.attribute_id) {
                                    options.forEach(function (o) {
                                        if (attribute.value.id === o.id) {
                                            errors = true;
                                            if (fail_options.length > 0) {
                                                if (fail_options.find(i => i.id !== o.id)) {
                                                    fail_options.push(o)
                                                }
                                            } else {
                                                fail_options.push(o)
                                            }
                                        }
                                    })
                                }
                            })
                        });

                        this.options_fail = fail_options;
                    }
                }

                if (!errors) {
                    if (this.currentRouteName === 'AddProduct') {
                        this.showAlert('Атрибут успешно сохранен', 'success', 'toast');
                        this.$emit('save_attribute', this.edit_attribute);
                        this.$refs['edit-options-modal'].hide()
                    } else {
                        const submitButton = this.$refs["save-attribute-button"];
                        submitButton.classList.add("spinner", "spinner-light", "spinner-right");

                        this.$store.dispatch(UPDATE_ATTRIBUTE_TO_PRODUCT, {
                            id: this.edit_attribute.id,
                            options: this.edit_attribute.options,
                            image: this.edit_attribute.image,
                            image_type: this.edit_attribute.image_type,
                            images: this.edit_attribute.images,
                        })
                            .then(() => {

                                this.$emit('save_attribute', this.edit_attribute);
                                this.showAlert('Атрибут успешно сохранен', 'success', 'toast');
                                this.$refs['edit-options-modal'].hide()
                            })
                            .catch(() => {
                                this.showAlert('Ошибка! Попробуйте позже', 'danger', 'toast');
                            })
                            .finally(() => {
                                submitButton.classList.remove("spinner", "spinner-light", "spinner-right")
                            })
                    }
                } else {
                    this.$refs['edit-options-modal'].hide();
                    this.$refs['edit-options-fail'].show();
                    this.showAlert('Невозможно удалить опции. Имеются вариации с данными опциями', 'danger', 'toast');

                }
            },


            hideModalDelOptionFail(){
                this.$refs['edit-options-fail'].hide()
            },


            deleteModal(){
                this.$refs['delete-attribute'].show()

            },

            hideModalDelete(){
                this.$refs['delete-attribute'].hide()
            },

            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },


            AddOption(){
                const submitButtonOption = this.$refs["add_option"];
                submitButtonOption.classList.add("spinner", "spinner-light", "spinner-right");


                const option = {
                    attribute: this.attribute.attribute_id,
                    name: this.new_option.name,
                    color: this.new_option.color
                };

                this.$store.dispatch(ADD_ATTRIBUTE_OPTION, option)
                    .then((data) => {
                        this.$store.dispatch(GET_ATTRIBUTES)
                            .then(() => {
                                this.edit_attribute.attribute.options.push(data.newoption);
                                this.edit_attribute.options.push(data.newoption);
                                this.showAlert('Опция успешно добавлена', 'success', 'toast');
                                this.new_option = { name: '', color: '#7461d1' }
                            })
                    })
                    .catch((response) => {

                        if (response.status === 422){
                            this.showAlert('Заполните все поля', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка, попробуйте позже. Код ошибки: ' + response.status, 'danger', 'toast');
                        }
                    })
                    .finally(() => {
                        submitButtonOption.classList.remove("spinner", "spinner-light", "spinner-right")
                    });
            },

        },


    }
</script>

<style scoped>

    .attribute{
        background-color: #f3f6f9;
        padding-top: 5px;
        padding-bottom: 5px;
        border-radius: 3px;
    }

    .ui-sortable .image{
        max-width: 100px;
        float: left;
        cursor: move;
        border: 1px solid #d5d5d5;
        margin: 9px 9px 0 0;
        background: #f7f7f7;
        border-radius: 2px;
        position: relative;
        box-sizing: border-box;
    }

    .ui-sortable {
        list-style: none;
        overflow:hidden
    }


    .ui-sortable i {
        cursor: pointer;
        position: absolute;
        background: red;
        padding: 6px;
        z-index: 5;
        color: #ffffff;
        font-size: 12px;
        border-radius: 5px;
        top: -4px;
        right: -4px;
    }

</style>